export function yearsBetweenDates(startDate: Date, endDate: Date = new Date()): number {
  // Check for invalid dates
  if (!startDate || isNaN(startDate.getTime())) {
    return 1;
  }

  // Get difference in years
  let years = endDate.getFullYear() - startDate.getFullYear();

  // Check if we've reached the anniversary date this year
  const hasPassedAnniversary =
    endDate.getMonth() > startDate.getMonth() ||
    (endDate.getMonth() === startDate.getMonth() && endDate.getDate() >= startDate.getDate());

  // Adjust if anniversary hasn't occurred yet this year
  if (!hasPassedAnniversary) {
    years--;
  }

  return Math.max(1, years);
}

export function yearsSinceJoinYear(joinYear: string): number {
  const parsed = parseInt(joinYear, 10);
  if (isNaN(parsed)) {
    return 1;
  }
  const currentYear = new Date().getFullYear();
  return Math.max(1, currentYear - parsed);
}
